import { useMutation, useQueryClient } from '@tanstack/react-query';
import { outfitService } from 'shared/src/api';
import { queryKey } from '../../../../../constant/queryKey';
import { useGoodsSno } from '../../../../../hooks/useGoodsSno';

export const useBookmarkOutfit = () => {
  const queryClient = useQueryClient();
  const goodsSno = useGoodsSno();

  return useMutation({
    mutationFn: ({
      sno,
      bookmarked,
    }: {
      sno: number;
      bookmarked: boolean;
    }) =>
      bookmarked
        ? outfitService.removeBookmark(sno)
        : outfitService.postBookmark(sno),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey.goodsRelatedOutfit(goodsSno),
      });
    },
  });
};
